export default "__VITE_ASSET__mCP0cHU2__"